import { createSlice } from "@reduxjs/toolkit";
import { IUser } from "../Intarfaces/IUser";
import { ILesson } from "../Intarfaces/ILesson";
import { ITest } from "../Intarfaces/ITest";
import test from './../test'



const userSlice = createSlice({
    name:"user",
    initialState:{
        isAuth:false,
        isInit:false,
        maxActiveLessonId:16,
        user:{
            id:null,
            full_name:'Салов Артём Владимирович',
            birthday:'11.07.2007',
            status:'аспирант',
            organization:'РГУ',
            education:'институт',
            email:'test@test.ru',
            phone:'89778958182'
        } as IUser|null,
        lessons:[
            {
                id:0,
                title: 'Занятие 1',
                tema: 'Социальная жизнь студентов с инвалидностью',
                lector:'Юдина Елена Николаевна',
                videos:['d70aaed07783e16aecd6ada17c1997a4/?p=Mt56zeJ5lxcaAWfP3SO8bA'],
                text:''
            } as ILesson,
            {
                id:1,
                title: 'Занятие 2',
                tema: 'Инклюзивная повестка в медиапространстве',
                lector:'Терентьева Елена Витальевна',
                videos:['aa1961bc3862d1dcd72040006f83db09/?p=uZeq89eXsEcDy4te1NLT4g'],
                text:''
            } as ILesson,
            {
                id:2,
                title: 'Занятие 3',
                tema: 'Права людей с инвалидностью: путь к инклюзивному обществу',
                lector:'Тенетко Алексей Алексеевич',
                videos:['59e226abd2a303745a4c7af4504d3469/?p=Ban2YASqLNuGzSiL-lKi2w'],
                text:''
            } as ILesson,
            {
                id:3,
                title: 'Занятие 4',
                tema: 'Права людей с инвалидностью и практика их реализации',
                lector:'Байрамов Фарман Джангир оглы',
                videos:['62e6d58031e25fbbc8bcfd8220133c99/?p=5GMmHalV2OEwyft2QzMehg'],
                text:''
            } as ILesson,
            {
                id:4,
                title: 'Занятие 5',
                tema: 'Правовая основа трудоустройства людей с инвалидностью',
                lector:'Черкашина Наталья Валерьевна',
                videos:['523b1377f58cbcf7e0c9cca25a2a5acc/?p=9727l4hq0M2aRwcCGBkN9A'],
                text:''
            } as ILesson,
            {
                id:5,
                title: 'Занятие 6',
                tema: 'Права людей с инвалидностью и практика их реализации: право на труд',
                lector:'Анна Черняева',
                videos:['0ce27ed0bafef0193be5b89057fecefd/?p=WKLCl1IEoA-D4VEa9xpoAw'],
                text:''
            } as ILesson,
            {
                id:6,
                title: 'Занятие 7',
                tema: 'Построение карьерной траектории инвалида в инклюзивной среде',
                lector:'Литвиненко Инна Леонтьевна',
                videos:['8ecd1fe8af32edbce2d6e3d725f4401f/?p=AG1k9LpSuK-b3OKFWroG7g'],
                text:''
            } as ILesson,
            {
                id:7,
                title: 'Занятие 8',
                tema: 'Платформы и сервисы по трудоустройству инвалидов',
                lector:'Трубачеев Евгений Валерьевич',
                videos:['1f1b254f2ed203cbd1e8d47afce590e7/?p=E5JN9rFE9Ay0Vr6FGodxZg'],
                text:''
            } as ILesson,
            {
                id:8,
                title: 'Занятие 9',
                tema: 'Возможности создания и продвижения некоммерческих организаций в сфере инклюзии',
                lector:'Трубачеев Евгений Валерьевич',
                videos:['aaf0cb2484a76ac66886d69b8d981932/?p=-xwZKm3ZdBcOm6YGML4bkw'],
                text:''
            } as ILesson,
            {
                id:9,
                title: 'Занятие 10',
                tema: 'Современные практики конструирования инклюзивного пространства в отношении людей с инвалидностью',
                lector:'Сёмочкина Наталья Николаевна',
                videos:['a1aa239a72c7c063e0f05910a475ac98/?p=hREOXYDbGRYgS4DTODNRcg'],
                text:''
            } as ILesson,
            {
                id:10,
                title: 'Занятие 11',
                tema: 'Познай себя, прими другого',
                lector:'Захарова Надира Летфулловна',
                videos:['70082e50559bbd783a07e6a7cb247492/?p=_b4ZKSiUT60_XmZYCVZN0g'],
                text:''
            } as ILesson,
            {
                id:11,
                title: 'Занятие 12',
                tema: 'Инклюзия как способ становления благополучной и жизнеспособной личности',
                lector:'Котовская Светлана Владимировна',
                videos:['705ab269d4d31cfb4b1952efc661363d/?p=7DraGV70hVAQtnEnapKjPA'],
                text:''
            } as ILesson,
            {
                id:12,
                title: 'Занятие 13',
                tema: 'Проектная деятельность: инструмент для достижения реальных результатов',
                lector:'Емельянова Алина Борисовна',
                videos:['55b479b50189e7e80043bc61bc45b2d6/?p=K4365ikgZqZKMbxp_qI5jg'],
                text:''
            } as ILesson,
            {
                id:13,
                title: 'Занятие 14',
                tema: 'Как сохранить физическую активность с ограниченными возможностями здоровья?',
                lector:'Бондаренко Андрей Владимирович',
                videos:['6b0a41fb8c66039dc9efc58eacd0ac08/?p=3awh8TUk__NXIB8Odf7oPQ'],
                text:''
            } as ILesson,
            {
                id:14,
                title: 'Занятие 15',
                tema: 'Виды комплексной реабилитации людей с ограниченными возможностями здоровья',
                lector:'Варфоломеев Дмитрий Леонидович',
                videos:['098fb1dc9ffb54eb650bb91dbbb0e69e/?p=uWevIwwnlAg16UrO1C3pgw'],
                text:''
            } as ILesson,
            {
                id:15,
                title: 'Занятие 16',
                tema: 'Основные вехи становления и развития мини-футбола (футзала) людей с синдромом Дауна в РФ',
                lector:'Махов Александр Сергеевич',
                videos:['244a3e3bf206404a9da26fcc5c6b2ad4/?p=trbjPy8jsfdiwrxqCOmj_A'],
                text:''
            } as ILesson,
            {
                id:16,
                title: 'Итоговое тестирование',
                tema: '',
                lector:'',
                videos:[],
                text:''
            } as ILesson

        ] as ILesson[],
        token:null as string|null,
        test:test

        
    },
    reducers:{
        setUser(state, actions:{payload:IUser, type:string}){
            state.user = actions.payload
        },
        init(state){

        },
        lastStep(state){
            state.maxActiveLessonId = state.maxActiveLessonId+1
        },
        setStep(state, actions:{payload:number, type:string}){
            state.maxActiveLessonId = actions.payload
        },
        setIsAuth(state, actions:{payload:boolean, type:string}){
            state.isAuth = actions.payload
        },
        getUser(state){
            
        }

    }
})

export default userSlice.reducer
export const {setUser, init, lastStep, getUser, setStep,  setIsAuth} = userSlice.actions